import { getLocalStore, setLocalStore } from './localStore';
import { LocalStoreKeys } from '../enums/localStoreKeys';
import { getSDKConfig } from './getSDKConfig';
import { SelectedGame } from '../types/SwipeSDKConfigType';
import { SwipeGamesItem } from '../model/swipe';

const getCurrentGameSelected = () => {
  const swipeSDKConfig = getSDKConfig();
  const gameListData: SwipeGamesItem[] =
    swipeSDKConfig?.swipeGames?.gameListConfig?.gameList ?? [];

  const defaultGameId: string | null =
    gameListData.length > 0 ? gameListData[0].gameId.toString() : null;

  const lastGameSession = getLocalStore(LocalStoreKeys.SELECTED_GAME);

  const isGameAvailable = gameListData.find(
    (game) => game.gameId == lastGameSession?.currentGameId,
  );
  const currentGameSelected: SelectedGame = isGameAvailable
    ? lastGameSession
    : {
        currentGameId: defaultGameId,
      };

  if (defaultGameId !== null) {
    setLocalStore(LocalStoreKeys.SELECTED_GAME, currentGameSelected);
  }

  return currentGameSelected;
};

export default getCurrentGameSelected;
